import React from 'react'
import { useCompanyDetailWorkflowsContextValue } from '../../context/CompanyDetailWorkflowProvider'
import { EditCompanyFileSchemaFlowProvider } from './context/EditCompanyFileSchemaFlowProvider'
import { EditCompanyFileSchemaFlowMain } from './components/EditCompanyFileSchemaFlowMain'

export const EditCompanyFileSchemaFlow = () => {
  const { editCompanyFileSchemaFlow } = useCompanyDetailWorkflowsContextValue()

  if (!editCompanyFileSchemaFlow.file) {
    return null
  }

  return (
    <EditCompanyFileSchemaFlowProvider>
      <EditCompanyFileSchemaFlowMain />
    </EditCompanyFileSchemaFlowProvider>
  )
}
